import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from 'src/app/shared/shared.module'
import { EventCardScrollComponent } from './event-card-scroll.component'
import { ThumbnailEventCardComponent } from 'src/app/libs/thumbnail-event-card/thumbnail-event-card.component'
import { SwiperModule } from 'swiper/angular'
import { CustomLinkModule } from 'src/app/libs/custom-link/custom-link.directive.module'
import { SvgModule } from 'src/app/shared/svg/svg.module'

@NgModule({
  imports: [CommonModule, SharedModule, SwiperModule, CustomLinkModule, SvgModule],
  exports: [EventCardScrollComponent],
  declarations: [EventCardScrollComponent, ThumbnailEventCardComponent]
})
export class EventCardScrollModule {}
